import { useEffect } from 'react';
import { debounce } from '../Helpers/debounce';

const activityEvents = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
const useInactivityMonitor = (
  inactivityDurationMs: number,
  onInactivity: (val: boolean) => void
) => {
  let inactivityTimeout: NodeJS.Timeout;

  const startActivity = () => {
    activityEvents.forEach((event) => {
      window.addEventListener(
        event,
        debounce(() => {
          movingActivity();
        }, 300)
      );
    });
  };

  const movingActivity = () => {
    clearTimeout(inactivityTimeout);
    setTimeout(() => {
      onInactivity(true);
      inactivityTimeout = setTimeout(() => {
        onInactivity(false);
      }, inactivityDurationMs);
    }, 500);
  };

  useEffect(() => {
    startActivity();
    return () => {
      clearTimeout(inactivityTimeout);
      activityEvents.forEach((event) => {
        window.removeEventListener(event, movingActivity);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useInactivityMonitor;
